export default {
    homeScreen : {
        startConversation: 'Start a conversation',
        newConversationButton: 'GET HELP',
        newMessageButton: '+ New Message',
        allTopics: 'All topics',
        allChatsButton: 'See all',
        poweredBy: 'Powered by Richpanel',
        reOpenConversation: 'Reopen Conversation',
        recentConversations: 'Your conversations',
        startAChat: 'Start A Chat',
        noRecentConversations: 'No recent conversations',
        noRecentOrders: 'No recent orders',
        haveAQuestion: "Have a question or just want to say 'hi'? We would love to hear from you.",
        conversationClosed: `This conversation has been marked as closed. If you have any queries regarding this issue, reopen this conversation.`,
        retry: 'Retry',
        errorOccured: 'Error occured while processing your request.',
        successMessage: 'We have received your request and the team will get in touch on {email} shortly',
        loadingMessage: 'Please wait. We are submitting your request.',
        goHome: 'OKAY',
        sendUsMessage: 'Send us a message',
        endChat: 'END CHAT',
        goto: 'Go to',
    },

    orderStatuses: {
        'completed': 'Completed',
        'pending': 'Pending',
        'on hold': 'On hold',
        'processing': 'Processing',
        'cancelled': 'Cancelled',
        'fulfilled': 'Fulfilled',
        'confirmed': 'Confirmed',
    },

    loginScreen: {
        title: 'Access your account',
        titleForOrdersScreenForward: 'Login to view orders',
        userIdFieldTitle: "Your phone or email",
        userIdFieldPlaceHolder: "Enter phone/email address",
        sendCode: "ENTER",
        enterCode: 'Enter the code we sent on',
        enterTheCode: 'Enter the code',
        notYourUserId: 'Not your {userIdType}?',
        userIdTypes: {
            'phone': 'number',
            'email': 'email',
        },
        change: 'Change',
        notReceivedCode: "If you didn't recieve the code?",
        resendCode: 'Resend',
        in: 'in',
        verifyCode: 'VERIFY',
        logout: 'Logout',
        orderNumberFieldTitle: 'Your order number',
        orderNumberFieldPlaceholder: 'Enter order number Ex: 1234',
        zipcodeFieldTitle: 'Your shipping pincode',
        zipcodeFieldPlaceholder: 'Enter shipping pincode',
        emailFieldTitle: 'Email',
        emailFieldPlaceholder: 'Enter email',
    },

    orderList : {
        reorder: 'REORDER',
        getHelp: 'GET HELP',
        startNewConversation: '+New Message',
        viewPreviousOrder:'VIEW ALL ORDERS',
        seeAll: 'See all',
        viewMoreOrders: 'VIEW MORE ORDERS',
        viewOrderStatus: 'VIEW ORDER STATUS',
        chatWithUs: 'CHAT WITH US',
        issueWithPreviousOrder:'HELP WITH PREVIOUS ORDERS' ,
        orderLabel: 'Order',
        help: 'HELP',
        lastOrder: 'Last Order',
        selectRelevantItems: 'Select relevant items',
        selectItemsErrorMsg: 'Please select items to proceed',
        selectAll: 'Select all',
        selectQuantity: 'How many items?',
        helpWithThisOrder: 'Help with this order',
        yourOrders: 'Your orders',
        view: 'VIEW',
        track: 'TRACK',
        addressTitle: 'Summary',
        billingAddressTitle: 'Billing address',
        shippingAddressTitle: 'Shipping address',
        receiptTitle: 'items',
        itemTotal: 'Item(s) total',
        taxes: 'Taxes',
        discounts: 'Discounts', 
        giftCard: 'Gift Card', 
        deliveryCharges: 'Delivery Charges',
        total: 'Total',
        loginToViewOrders: 'Existing customer?',
        loginSuggestion: "Get expedited help & order support",
        trackingOrderLabel: 'Track order',
        shipmentDescription: "Come back to this page for updates on your shipment status",
        free: "free",
        selectedItems: "Selected Items",
        items: "items",
        "orderSearchPlaceholder": 'Filter by order #',
        "noOrderFound": 'No orders matching {orderId}',
    },
    chatListScreen: {
        header: 'Your Conversations',
    },
    sentences: {
        "IN_A_DAY" : "The team typically replies in a day.",
        "IN_FEW_MINUTES": "The team typically replies in a few minutes.",
        "IN_FEW_HOURS": "The team typically replies in a few hours.",
        "AS_SOON_AS_THEY_CAN": "The team will reply as soon as they can",
        "BACK_ON": "Back on",
        "BACK_IN": "Back in",
        "HOURS": "Hours",
        "MINUTES": 'Minutes',
        provideBelowDetails: "Please provide the below details",
    },
    inputFields: {
        submitted: 'submitted'
    },
    inputPropDisplayNames: {
        "email": "Email",
        "phone": "Phone",
        "Phone": "Phone",
        "firstName": "First Name",
        "lastName": "Last Name",
        "uid": "User Id",
        "campaign": "UTM Campaign",
        "medium": "UTM Medium",
        "googleplus": "Google plus",
        "shippingPhone": "Shipping Phone",
        "source": "UTM Source",
        "lastOrderAt": "Last Order Time",
        "firstOrderAt": "First Order Time",
        "visits": "Sessions",
        "facebook": "Facebook",
        "twitter": "Twitter",
        "updatedAt": "Last Seen",
        "createdAt": "First Seen",
        "linkedin": "Linkedin",
        "instagram": "Instgram",
        "pinterest": "Pinterest",
        "tumblr": "Tumblr",
        "billingEmail": "Billing Email",
        "billingPhone": "Billing Phone",
        "shippingEmail": "Shipping Email",
        "state": "State",
        "city": "City",
        "country": "Country",
        "deviceType": "Device type",
        "browserName": "Browser name",
        "osName": "Os name",
        "platform": "platform",
        "ltv": "CLV",
        "ordersCount": "Orders Count",
        "name": "Name",
        "RichpanelPredictedCLV": "Predicted CLV",
        "RichpanelAliveProbability": "Likelihood To Buy",
        "RichpanelNextOrderDate": "Next Order Date",
        "RichpanelPredictedOrderCount": "Predicted Order Count",
        "aov": "AOV",
        "WebsiteURL":"Website URL"
    },
    botMessages: {
        EXISITING_CUSTOMER: 'Are you an existing customer?',
        YES_EXISITING_CUSTOMER: "Yes, I'm a customer",
        NO_EXISITING_CUSTOMER: "No, I'm not a customer yet",
        GIVE_THE_TEAM_WAY_TO_REACH_YOU: "Give the team a way to reach you.",
        YOU_WILL_BE_NOTIFIED_EMAIL: "You'll be notified here and on email ({email}) when they reply.",
        YOU_WILL_BE_NOTIFIED_NO_EMAIL: "You'll be notified here when they reply.",
        LEAVE_YOUR_MESSAGE: "Please leave your message.",
        TEAM_WILL_BE_BACK_IN:"The team will be back in {hours} hours",
        TEAM_WILL_BE_BACK_ON:"The team will be back on {availableAt}",
        FEW_MORE_DETAILS: "Thanks! A few more details will help assign you to the right person:",
    },
    initialForm: {
        heading: 'Please enter your details to start the chat',
        startChat: 'Start Chat'
    },
    customerJourneyPreChatForm: {
        heading: 'Start a chat',
        startChat: 'Start chat',
        proceed: 'Proceed',
        canWeHelpWithAnythingElse: 'Do you need help with any thing else?',
        yes: 'Yes',
        no: 'No',
        noThanks: "Okay, thanks",
        yesContactSupport: "Chat with support",
        contactSupport: "Contact Support",
    },
    rating: {
        askedHeader: 'Rate your conversation',
        successHeader: 'You rated this conversation',
        thanksMessage: "Thanks for letting us know",
        placeholderForRatingFeedback: "Please write your feedback"
    },
    placeholders: {
        emojiSearch: 'Search Emojis',
        typeAMessage: 'Click to reply',
        searchGifs: 'Search GIFs',
    },
    lastMessageText: {
        sentAGif: 'Sent a GIF',
        sharedFile: 'Shared a file',
        askedForQualificationDetails: 'Asked for qualification details.',
        askedForRating: 'Asked for rating',
        askedForFeedback: 'Asked for feedback',
        sharedOrderSummary: "Shared order summary"
    },
    greetingAnimation: {
        weAreOnline: 'We are online',
        askUsAnything: 'Ask us anything',
        chatWithUs: 'Chat with us'
    },
    errorMessages: {
        enterEmailOrPhone:  "Please enter email/phone",
        enterValidOrPhone: "Enter valid email/phone",
        userNotFound: "We couldn’t find an account with this phone/ email",
        enterCode: 'Please enter login code',
        invalidCode: 'Invalid code'
    }
}